export default class VariableModel {
    idNVariable: number | null;
    fkNTipoVariable: number | null;
    fkNElemento: number | null;
    fkNAgrupacionVariable: number | null;
    fldTNombre: string | null;
    fldBActiva: number | null;
    fldBLectura: number | null;
    fldBEscritura: number | null;

    constructor() {
        this.idNVariable = null;
        this.fkNTipoVariable = null;
        this.fkNElemento = null;
        this.fkNAgrupacionVariable = null;
        this.fldTNombre = null;
        this.fldBActiva = null;
        this.fldBLectura = null;
        this.fldBEscritura = null;
    }
}